import { Component, OnInit } from '@angular/core';
import { AuthService } from './core/auth.service';
import { Router } from '@angular/router';
import { SessionTimeoutService } from './core/session-timeout.service';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private router: Router,
    private sessionTimeout: SessionTimeoutService
  ) {}

  ngOnInit() {
    this.auth.refreshUserFromStorage(); // ensures token & user ready before requests
    this.sessionTimeout.startWatching();
  }
}
